// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.connector-item[data-v-7e891386] {\n\tborder: 1px solid #e0e0e0;\n\tborder-radius: 4px;\n\tpadding: 8px;\n}\n.copy-icon[data-v-7e891386] {\n\tcursor: pointer;\n\topacity: 0.6;\n}\n.copy-icon[data-v-7e891386]:hover {\n\topacity: 1;\n}\n.session-item[data-v-7e891386] {\n\tpadding: 4px 0;\n\tborder-top: 1px dashed #eee;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
